module.exports = __webpack_public_path__ + "img/32.f6b436ce.png";